<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <!-- Alert message -->
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- main content -->
    <!-- Header Component -->
    <div>
      <HeaderComponent :headerTitle="headerText" />
    </div>

    <!--  view error log popup -->
    <v-row justify="center">
      <v-dialog v-model="viewErrorLogPopup" persistent max-width="900px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex">
            <span>Error Log(Voltas CRM Inbound) <span style="font-size:10px;font-weight:600;color:#9C9C9C;">Creation Date: 12/04/2024 12:10PM</span></span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="viewErrorLogPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-50 m-0"/>
          <v-card-text class="text-left">
            <!-- <h6>{{this.error_log_data}}</h6> -->
            <v-row>
              <v-col cols="12" sm="3" md="3">
                <strong>Request Payload :</strong>
              </v-col>
              <v-col cols="12" sm="9" md="9">
                {{this.request_log}}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="3" md="3">
                <strong>Response Payload :</strong>
              </v-col>
              <v-col cols="12" sm="9" md="9">
                {{this.response_log ? this.response_log : this.error_log_data}}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <!--  add comment popup -->
    <v-row justify="center">
      <v-dialog v-model="addCommentPopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex">
            <span v-if="this.comment_data">Comments (Voltas CRM Inbound)</span>
            <span v-else>Add Comment</span>
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="addCommentPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-50 m-0"/>
          <v-card-text class="text-center" v-if="isViewComment == false">
            <v-textarea v-model="newComment" rows="10" required cols="50" label="Add comment" height="100" variant = "outlined"> </v-textarea>
          </v-card-text>
          <v-card-actions class="margin-10 d-flex justify-center block" v-if="isViewComment == false">
            <v-spacer></v-spacer>
            <v-btn small text color="primary" class="text-none" @click="addCommentPopup = false" variant="outlined">Cancel</v-btn>
            <v-btn small color="primary" class="text-none" @click="submitComment()" variant="flat">Submit</v-btn>
          </v-card-actions>
          <v-container v-if="isViewComment == true">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <span class="ma-2">{{this.comment_data ? this.comment_data : 'No Comment Found'}}</span>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- filter data popup -->
    <v-row justify="center">
      <v-dialog content-class="filter-3p" v-model="filtersPopup" persistent max-width="1224px" style="max-width: auto;">
        <v-card class="filter_ui">
          <v-card-actions>
            <v-text-field v-model="filterErrorType" prepend-inner-icon="mdi-magnify" item-title="name" item-value="id"
              class="ma-2" variant="outlined" label="Error Type" style="max-width:300px;"></v-text-field>
            <v-combobox v-model="filterErrorCode" prepend-inner-icon="mdi-magnify" :items="filterErrorItems" item-title="name"
              item-value="id" label="Error Code" variant = "outlined" class="ma-2" style="max-width:300px;"></v-combobox>
            <v-combobox v-model="filterStatus" prepend-inner-icon="mdi-magnify" :items="statuses" item-title="name"
            item-value="id" label="Status" variant = "outlined" class="ma-2" style="max-width:300px;"></v-combobox>
            <v-menu ref="menu_16" v-model="menu_16" :close-on-content-click="false" :return-value.sync="filter_date"
              transition="scale-transition" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field variant = "outlined" v-model="filter_date" label="Date" prepend-inner-icon="event" readonly
                  v-bind="attrs" v-on="on" style="max-width: 
                    300px;" class="ma-2"></v-text-field>
              </template>
              <v-date-picker v-model="filter_date" no-title scrollable style="max-width: 300px;">
                <v-spacer></v-spacer>
                <v-btn text color="primary" variant="outlined"  class="text-none" @click="menu_16 = false">Cancel</v-btn>
                <v-btn text color="primary" variant="flat" class="text-none" @click="$refs.menu_16.save(filter_date)">Ok</v-btn>
              </v-date-picker>
            </v-menu>
          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn small text color="normal" variant="outlined" class="text-none" @click="cancelFilterpopup">Cancel</v-btn>
            <v-btn small color="primary" variant="flat" class="text-none" @click="applyFilterFunc()">Apply Filter(s)</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- For showing tabs -->
    <v-card class="v-card-100 mt-6">
      <v-tabs v-model="tab_index">
        <!-- <div> -->
          <!-- <v-menu v-model="subTabsActive" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-tab class="component-tab-heading"v-on="on" v-bind="attrs" style="text-transform:none; padding: 0px 0px !important">
                <span style="width: 100px !important; padding: 12px 0px;">{{ selectedSubtab }}
                  <v-icon>{{ subTabsActive ? 'mdi-menu-up' : 'mdi-menu-down' }}</v-icon>
                </span>
              </v-tab>
            </template>
            <v-list v-for="(subtab, index) in subTabs" :key="subtab" class="py-0">
              <v-list-item
                  :disabled="subtab==selectedSubtab"
                  @click="loadData(subtab, 'subtab_clicked1', index)"
                  style="cursor: pointer;">
                  {{ subtab }} 
              </v-list-item>
            </v-list>
          </v-menu> -->
        <!-- </div> -->
        <v-tab class="component-tab-heading"ripple :href="'#'" style="text-transform:none!important;" @click="loadData(tab, 'tab_clicked')"
          v-for="(tab, index) in tabs" :key="index">{{
            tab }}</v-tab>
      </v-tabs>
    </v-card>

    <!-- For showing Filters and Action buttons -->
    <v-card-title class="action-style pb-0">
      <v-row class="ma-3">
        <v-col cols="8" sm="8" class="pb-0 px-0">
          <v-text-field prepend-inner-icon="mdi-magnify" v-model="item_search" v-no-edge-space label="Search" style="max-width: 300px;"
            variant = "outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
        </v-col>
        <v-spacer></v-spacer>
        <v-expansion-panels class="custom-control_outlined m-0 pt-4" ref="filterPopupRef" readonly style="max-width: 300px; margin-bottom: 18px; height: 52px;">
          <v-expansion-panel variant="outlined" @click="listFiltersData">
            <v-expansion-panel-title>Filter
            </v-expansion-panel-title>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
    </v-card-title>
    <v-layout column>
      <!-- <v-flex md6 style="overflow: auto"> -->
        <v-data-table hover
          density="compact"
          :search="search"
          v-model="selected"
          hide-select
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data"
          :loading="loading"
          :items-per-page="pageSize"
          fixed-header
          height="100%"
          loading-text="Loading Data... Please wait" class="elevation-1"
          return-object
          >
          <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers">
              <span v-if="header.key == 'api_name'">
                <a href="#" @click.prevent="openApiDetail(item, item.api_name)" style="text-decoration: underline !important; color: #1976d2 !important; cursor: pointer !important;">{{ item.api_name }}</a>
              </span> 
              <span v-else-if="header.key == 'error_log'">
                <a @click="itemDetailpopup(item)" style="color: #1976d2;">
                  <u>View</u>
                </a>              
              </span>
              <span v-else-if="header.key == 'created_at'">
                {{ item.created_at ? formatTimestamp(item.created_at) : '-' }}
              </span> 
              <span v-else-if="header.key == 're_trigger'">
                <v-btn class="m-2" label="RE-TRIGGER" :disabled="item.re_trigger" variant = "outlined" color="primary" @click="retrigger(item)">{{  item.re_trigger ? 'RE-TRIGGERED' : 'RE-TRIGGER' }}</v-btn>
              </span> 
              <span v-else-if="header.key == 'comments'">
                <span v-if="item.comments">
                <a href="#" @click.prevent="openCommentpopup(item)" style="text-decoration: underline !important; color: #1976d2 !important; cursor: pointer !important;">View Comment</a>
              </span>
              <span v-else> 
                <a href="#" @click.prevent="openCommentpopup(item)" style="text-decoration: underline !important; color: #1976d2 !important; cursor: pointer !important;">Add Comment</a>
              </span>
              </span> 
              <span v-else-if="header.key !== 'images' && item[header.key]">
                <span v-tooltip="item[header.key]">
                  {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                </span>
              </span>
              <span v-else>-</span>
            </template>
          <!-- <template #[`item.api_name`]="{ item }" v-if="this.active_tab === 'API Level'">
            <a @click="openApiDetail(item, item.api_name)" style="color: #1976d2;">
              <u> {{ item.api_name ? item.api_name : '-'}}</u>
            </a>
          </template> -->
          <!-- <template #[`item.error_type`]="{ item }" v-if="this.active_tab === 'Overall'">
            {{ item.error_type ? item.error_type : '-'}}
          </template>
          <template #[`item.api_description`]="{ item }" v-if="this.active_tab === 'API Level'">
              {{ item.api_description ? item.api_description : '-'}}
          </template> -->

          <!-- <template #[`item.error_log`]="{ item }">
            <a @click="itemDetailpopup(item)" style="color: #1976d2; cursor: pointer;" v-if="item.error_log && item.error_log['Error Message'] !== ''">
              <u>View</u>
            </a>
            <span v-else>-</span>
          </template> -->
          <!-- <template #[`item.error_code`]="{ item }">
              {{ item.error_code ? item.error_code : '-' }}
          </template> -->
          <!-- <template #[`item.created_at`]="{ item }">
              {{ item.created_at ? formatTimestamp(item.created_at) : '-' }}
          </template>
          <template #[`item.re_trigger`]="{ item }">
            <v-btn class="m-2" label="RE-TRIGGER" :disabled="item.re_trigger" variant = "outlined" color="primary" @click="retrigger(item)">{{  item.re_trigger ? 'RE-TRIGGERED' : 'RE-TRIGGER' }}</v-btn>
          </template>
          <template #[`item.comments`]="{ item }">
            <a @click="openCommentpopup(item)" style="color: #1976d2; cursor: pointer;" v-if="item.comments">
              <u>View Comment</u>
            </a>
            <a @click="openCommentpopup(item)" style="color: #1976d2; cursor: pointer;" v-else>
              <u>Add Comment</u>
            </a>
          </template> -->
          <template #bottom></template>
        </v-data-table>
      <!-- </v-flex> -->
    </v-layout>

    <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />
  </v-card>
</template>
<script>
import HeaderComponent from '../../../commoncomponents/HeaderComponent.vue';
import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';

export default {
  data() {
    return {
      headerText: 'API Logs',
      alert_type: 'success',
      alert_message: '',
      alert: false,
      selected: [],
      loading: false,
      active_tab: 'Overall',
      tab_name: 'Overall',
      tabs: [
        "Overall",
        "API Level"
      ],
      // subTabs : [
      //   "All",
      //   "Success",
      //   "Failed"
      // ],
      // subTabsActive:false,
      // selectedSubtab : "All",
      headers: [
        { title: "API Name", key: "api_name", sortable: false },
        { title: "API Description", key: "api_description", sortable: false },
        { title: "Error Type", key: "error_type" },
        { title: "Error Code", key: "error_code" },
        { title: "Error Log", key: "error_log" },
        { title: "Date & Time", key: "creation_date" },
        { title: "Date & Time", key: "creation_date" },
        { title: "Ageing", key: "ageing" },
        { title: "Re-Trigger", key: "re_trigger" },
        { title: "Comment", key: "comments" },
        { title: "Status", key: "status" },

      ],
      table_data: [],
      page: 1,
      totalPages: 1,
      totalCount: '',
      pageSize: defaultPageSize,
      pageSizes: defaultPageSizes,
      newComment: '',
      item_search: '',
      filtersPopup: false,
      filter_date: '',
      menu_16: false,
      filterErrorType: '',
      filterErrorItems: [],
      filterErrorCode: null,
      viewErrorLogPopup: false,
      addCommentPopup: false,
      isTriggeredBtn: false,
      isViewComment: false,
      comment_data: '',
      error_log_data: '',
      statuses: [
        'All',
        'Success',
        'Failed'
      ],
      filterStatus: null,
      request_log:'' ,
      response_log:'',
      tab_index: 0,
    }
  },
  components: {
    HeaderComponent
  },
  async created() {
    this.organization_name = this.$store.state.organization_name;
     this.active_tab_condi = this.$store.state.active_tab;
     if(this.active_tab_condi === 'first_tab'){
        this.tab_index = 0;
        this.loadData('Overall');
      }else if(this.active_tab_condi === 'second_tab'){
        this.tab_index = 1;
        this.loadData('API Level');
      }else{
        this.loadData('Overall');
      }
    this.scrollToTop();
  },
  methods: {
    listFiltersData(ev) {
      this.item_search = '';
      this.filtersPopup = true;
      this.filter_date = '';
      this.filterErrorType = '';
      this.filterErrorCode = null;
      document.documentElement.style.setProperty('--dialog-ypos', (this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 40).toString() + 'px');
      this.$httpSecured
      .get("/api/v2/api_log_configurations/filter_data")
      .then(response => {
        if (response.data) {
          this.filterErrorItems = response.data.error_codes.flat();
          this.loading = false;
        } else {
          this.loading = false;
          this.showAlert("error", "No Data Found");
        }
      })
      .catch(error => {
        this.showAlert("error", "Something went wrong from Network" + error);
        this.loading = false;
      });
    },
    getRequestParams(page, pageSize, filterPageNo) {
      let params = {};

      if (page) {
        params["page"] = page;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      if (filterPageNo) {
        params["filterPageNo"] = filterPageNo
      }
      return params;
    },
    showAlert(alert_type, alert_message) {
      this.scrollToTop();
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.alertTimeOut();
    },
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
    handlePageChange(value) {
      this.page = value;
      if (this.isFiltering) {
        this.filterPage = value;
        this.applyFilterFunc();
        return;
      }
      this.fetchingErrorListingData();
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.filterPage = 1;
      if (this.isFiltering) {
        this.applyFilterFunc();
        return;
      }
      this.fetchingErrorListingData();
    },
    cancelFilterpopup() {
      this.filtersPopup = false;
      this.filter_date = '';
      this.filterErrorType = '';
      this.filterErrorCode = null;
    },
    formatTimestamp(timestamp) {
      const date = new Date(timestamp);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      let hour = date.getHours();
      const minute = date.getMinutes();
      const amPM = hour >= 12 ? 'PM' : 'AM';
      hour = hour % 12 || 12;
      const formattedTime = `${hour}:${minute.toString().padStart(2, '0')} ${amPM}`;
      return `${day}/${month}/${year}, ${formattedTime}`;
    },
    loadData(tab, tab_action) {
      if (tab_action) {
        this.item_search = ''
      }
      this.loading = true;
      this.selected = []
      this.active_tab = tab
      this.table_data = []
      this.page = 1
      this.totalPages = 1
      this.filterPageNo = 1
      this.isFilteringPage = false
      if (tab == "Overall") {
        this.$store.commit("setActiveTab", {
              active_tab:'first_tab'
              }); 
        (this.headers = [
          { title: "API Name", key: "api_name", sortable: false },
          // { title: "Error Type", key: "error_type" },
          // { title: "Error Code", key: "error_code" },
          // { title: "Error Log", key: "error_log" },
          // { title: "Date & Time", key: "created_at" },
          // { title: "Ageing", key: "ageing" },
          // { title: "Re-Trigger", key: "re_trigger" },
          // { title: "Comment", key: "comments" },
          { title: "Status", key: "status" },
          { title: "Code", key: "error_code" },
          { title: "Logs", key: "error_log" },
          { title: "Date & Time", key: "created_at" },
          { title: "Ageing", key: "ageing" },
          { title: "Re-Trigger", key: "re_trigger" },
          { title: "Comment", key: "comments" },
        ]);
        this.fetchingErrorListingData();
      }
      if (tab == "API Level") {
        this.$store.commit("setActiveTab", {
              active_tab:'second_tab'
              }); 
        (this.headers = [
          { title: "API Name", key: "api_name", sortable: false },
          { title: "API Description", key: "error_type", sortable: false },
        ]);
        this.fetchingAPIConfigurationData();
      }
    },

    fetchingErrorListingData() {
      const params = this.getRequestParams(
        this.page,
        this.pageSize
      );
      const requestParams = {
        page: params.page,
        per_page: params.size,
        tab: this.active_tab,
        search: this.item_search,
      };
      this.$httpSecured
        .get('/api/v2/api_payloads?filter[status]=failed', { params: requestParams })
        .then(response => {
          if (response.data) {
            this.table_data = response.data.api_payloads
            this.table_data = this.table_data.map(item => ({
              ...item,
              re_trigger: item.re_trigger || false,
            }));
            this.totalPages = response.data.meta.total_pages
            this.totalCount = response.data.meta.total_count
            this.filtersPopup = false;
            this.filter_date = '';
            this.filterErrorCode = null;
            this.filterErrorType = '';
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    fetchingAPIConfigurationData() {
      const params = this.getRequestParams(
        this.page,
        this.pageSize
      );
      const requestParams = {
        page: params.page,
        per_page: params.size,
        search: this.item_search,
      };
      this.$httpSecured
        .get("/api/v2/api_log_configurations", { params: requestParams })
        .then(response => {
          if (response.data) {
            this.table_data = response.data.api_log_configurations;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    applyFilterFunc(){
      const params = new URLSearchParams();
      params.append('page', this.page);
      params.append('per_page', this.pageSize);
      params.append('search', this.item_search);
      params.append('filter[status]', this.filterStatus);
      params.append('filter[date]', this.filter_date);
      params.append('filter[error_code]', this.filterErrorCode);
      if(this.filterStatus === 'Success'){
        params.append('filter[status]', 'success');
      }else if(this.filterStatus === 'Failed'){
        params.append('filter[status]', 'failed');
      }

      const requestParams = params;
      this.$httpSecured
        .get("/api/v2/api_payloads", { params: requestParams })
        .then(response => {
          if (response.data) {
            this.table_data = response.data.api_payloads
            this.totalPages = response.data.meta.total_pages
            this.totalCount = response.data.meta.total_count
            this.filtersPopup = false;
            this.filter_date = '';
            this.filterErrorCode = null;
            this.filterErrorType = '';
            this.filterStatus = null;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    openApiDetail(item, action) {
      this.$store.commit("setRequestDetails", {
        actionRequest: action,
        items: '',
      });
      if (action == item.api_name) {
        this.$router.push({ name: 'ApiLevelErrorListing' });
      }
      this.loading = false;
        
    },
    itemDetailpopup(item) {
      this.error_log_data = item.error_log ? item.error_log.error_message : "No error message available";
      this.request_log = item.request_payload;
      this.response_log = item.response_payload;
      this.viewErrorLogPopup = true;
    },
    retrigger(item) {
      this.$httpSecured
        .post(`/api/v2/api_payloads/${item.id}/retry`)
        .then(response => {
          if (response.data) {
            this.$toast.success(response.data.message);
            this.$set(item, 're_trigger', true);
            setTimeout(() => {
              this.$set(item, 're_trigger', false);
            }, 300000);
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert('error', error.response.data.message)
          // this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    openCommentpopup(item) {
      this.comment_data = item.comments
      this.addCommentPopup = true;
      this.comment_data ? this.isViewComment = true : this.isViewComment = false;
      this.selected = item
    },
    submitComment() {
      const item_id = this.selected.id
      const requestParams = {
        comments: this.newComment
      };
      this.$httpSecured
        .put(`/api/v2/api_payloads/${item_id}/update_comment`, requestParams)
        .then(response => {
          if (response.data) {
            this.addCommentPopup = false;
            this.isViewComment = true;
            this.selected = [];
            this.showAlert('success', response.data.message);
            this.fetchingErrorListingData();
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert('error', error.response.data.message)
          // this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
      
    },
  }
}
</script>
<style scoped>
  .custom-control_outlined .v-expansion-panel:before {
    box-shadow: none;
  }
  .custom-control_outlined button {
    min-height: 56px;
    border-width: 1px;
    border-color: rgba(0,0,0,.42);
    border-style: solid;
  }
  .v-dialog:has(.filter-3p){
    justify-content: right;
    align-items: baseline;
    top: var(--dialog-ypos);
  }
  .custom-control_outlined button:focus {
    outline: none;
  }
  .v-menu__content {
    min-width: 100px !important;
  }
  .v-dialog>.v-card>:has(.v-card__title){
    overflow-wrap: break-word !important;
  }
  .v-data-table {
    height: calc(var(--vh, 1vh) * 100 - 328px) !important;
  }
  .filter_ui{
    margin-left: 18px !important;
    margin-top: 15px !important;
  }
</style>